module.exports = __webpack_public_path__ + "static/icon7-4d7c9a26eeb5b1ff3dae8a3ca8c2c7e1.svg";